import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRepository } from './base.repository';

@Injectable({
 providedIn: 'root',
})
export class SearchRepository extends BaseRepository {
 fetchHotelInfoSuggest(query: string, accomodation: boolean): Observable<any> {
  const url =
   this.baseUrl +
   (accomodation ? 'v1/accomodation/suggest' : `hotelInfo/suggest`) +
   `?query=${query}&take=20`;
  return this.getWithoutCache<any>(url);
 }

 getCurrentDate() {
  const url = this.baseUrl + 'common/GetCurrentDate';
  return this.getWithoutCache<{ Value: string }>(url);
 }

 getHolidays(range: { StartDate: string; EndDate: string }): Observable<string[]> {
  const url =
   this.baseUrl + `common/GetHolidays?StartDate=${range.StartDate}&EndDate=${range.EndDate}`;
  return this.getWithoutCache<string[]>(url);
 }

 proformEcolodgeInvoice(
  StartDate: string,
  EndDate: string,
  FixedGuestCount: string,
  ExtraGuestCount: string,
  HouseId: string,
  Type = '2'
 ) {
  const url =
   this.baseUrl +
   `v1/accomodation/proforma?StartDate=${StartDate}&endDate=${EndDate}&FixedGuestCount=${FixedGuestCount}&ExtraGuestCount=${ExtraGuestCount}&HouseId=${HouseId}&Type=${Type}`;
  return this.getWithoutCache<any>(url);
 }
}
